<svg ref="svg" class="tt-o-icon" :class="classes" :aria-hidden="ariaHidden" :focusable="ariaHidden ? 'false' : 'true'" v-on="$listeners">
  <title v-if="title">{{title}}</title>
  <use v-bind:xlink:href="iconId" />
</svg>


// WEBPACK FOOTER //
// ./src/objects/icon/icon.html